import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { Box } from '~/eds/src/components/Box/Box';
import { Modal } from '~/eds/src/components/Modal/Modal';
import { Nullable } from '~/types/Nullable';

import { DocumentViewer, Props as DocumentViewerProps } from './DocumentViewer';
import type { ResolvedDocument } from './types/document';

interface Props {
  documentViewer: DocumentViewerProps;
  isVisible: boolean;
  onHide: () => void;
}

export const DocumentViewerModal = ({
  documentViewer,
  isVisible,
  onHide,
}: Props) => {
  const [resolvedDoc, setResolvedDoc] =
    useState<Nullable<ResolvedDocument>>(null);
  const intl = useIntl();

  return (
    <Modal
      isVisible={isVisible}
      title={
        resolvedDoc?.file.name ??
        intl.formatMessage({
          id: 'DocumentViewerModal.title',
          defaultMessage: 'Document Viewer',
          description: 'Default title for document viewer modal',
        })
      }
      titleLink={
        resolvedDoc
          ? { pathname: `/document/${resolvedDoc.documentId}/` }
          : undefined
      }
      onHide={onHide}
    >
      <Box styles={{ height: '60vh' }}>
        <DocumentViewer
          {...documentViewer}
          onResolveDocument={setResolvedDoc}
        />
      </Box>
    </Modal>
  );
};
